import React, { useMemo } from 'react';

import { cn } from '@/lib/utils';

import { AddButton } from './add-button';
import { DayButton } from './day-button';

export type DateBoxView = 'day' | 'week' | 'month';
export type DateBoxProps = {
  view: DateBoxView;
  date: Date;
  onAdd: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  onDoubleClick?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  children?: React.ReactNode;
};

export function DateBox(props: DateBoxProps) {
  const day = useMemo(() => props.date.getDate(), [props.date]);

  const children = React.Children.toArray(props.children);
  const showTwoColumns = props.view === 'month' && children.length > 4;

  return (
    <div
      className={cn(
        'gap-1 border border-slate-200 p-1',
        props.view === 'week'
          ? 'grid h-full grid-rows-[min-content_minmax(0,1fr)] overflow-hidden'
          : props.view === 'month'
            ? 'grid h-full grid-rows-[min-content_minmax(0,1fr)] overflow-hidden'
            : 'flex h-full flex-col',
        props.className,
      )}
    >
      <div className="flex items-center justify-between">
        <DayButton
          day={day}
          onClick={props.onClick}
          onDoubleClick={props.onDoubleClick}
          disabled={props.disabled}
        />

        <AddButton disabled={props.disabled} onClick={props.onAdd} />
      </div>
      <div
        className={cn(
          props.view === 'month'
            ? [
                'grid content-start gap-0.5 overflow-y-auto pr-0.5',
                showTwoColumns && 'grid-cols-2',
              ]
            : 'flex flex-col gap-1',

          props.view === 'week' && 'overflow-y-auto pr-0.5',
        )}
      >
        {children}
      </div>
    </div>
  );
}
